export function locusMode(value = '') {
    return /(?:^|:)p\./i.test(value) ? 'protein' : /(?:^|:)c\./i.test(value) ? 'cDNA' : 'locus';
}

export function annotationOptions(rows = [], mode = 'locus') {
    if (mode === 'locus') return rows.map(row => ({ value: row.value, label: `${row.label} · ${row.coordinate}` }));
    const values = new Map();
    for (const row of rows) {
        for (const term of String(row[mode] || '').split(/[,;|\s]+/).filter(Boolean)) {
            if (!(mode === 'cDNA' ? /(?:^|:)c\./i : /(?:^|:)p\./i).test(term)) continue;
            if (!values.has(term.toLowerCase())) values.set(term.toLowerCase(), { value: term, label: term });
        }
    }
    return [...values.values()].sort((a, b) => a.value.localeCompare(b.value));
}

export function pm3Label(value) {
    return value === null || value === undefined || String(value).trim() === '' ? "Not supplied" : String(value);
}
